import Vue from 'vue'
import http from '@/utils/ajax'
import { ADMINUSER_INIT_LOADING, ADMINUSER_INIT_SUCCESS, ADMINUSER_INIT_FAIL, ADMINUSER_INTERMEDIARY, ADMINUSER_SECURITY_LOADING, ADMINUSER_SECURITY_SUCCESS, ADMINUSER_SECURITY_FAIL, ADMINUSER_PRIVILEGE_LOADING, ADMINUSER_PRIVILEGE_SUCCESS, ADMINUSER_PRIVILEGE_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // API menu
  menu: {},
  intermediaryList: [],
  security: {
    init: 0,
    initErr: [],
    menu: {}
  },
  privilege: {
    init: 0,
    initErr: [],
    menu: {}
  },
  member: {
    trans: null,
    tabMenu: {
      tab: 0,
      displayReviewTab: false
    },
    tabMiscMenu: {
      display: false,
      text: ''
    }
  }
}

const getters = {

}

const mutations = {
  [ADMINUSER_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [ADMINUSER_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [ADMINUSER_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [ADMINUSER_INTERMEDIARY](state, data) {
    Vue.set(state, 'intermediaryList', data)
  },
  [ADMINUSER_SECURITY_LOADING](state) {
    state.security.init = 0
    state.security.initErr = []
    state.security.menu = {}
  },
  [ADMINUSER_SECURITY_SUCCESS](state, data) {
    state.security.init = 1
    state.security.initErr = []
    state.security.menu = data.menu
  },
  [ADMINUSER_SECURITY_FAIL](state, error) {
    state.security.init = 2
    state.security.initErr = error
    state.security.menu = {}
  },
  [ADMINUSER_PRIVILEGE_LOADING](state) {
    state.privilege.init = 0
    state.privilege.initErr = []
    state.privilege.menu = {}
  },
  [ADMINUSER_PRIVILEGE_SUCCESS](state, data) {
    state.privilege.init = 1
    state.privilege.initErr = []
    state.privilege.menu = data.menu
  },
  [ADMINUSER_PRIVILEGE_FAIL](state, error) {
    state.privilege.init = 2
    state.privilege.initErr = error
    state.privilege.menu = {}
  }
}

const actions = {
  async userManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.userManagement
    commit(ADMINUSER_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(ADMINUSER_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(ADMINUSER_INIT_FAIL, extractMessages(error))
    }
  },
  async userSecurityInit({ commit, state }) {
    const apiUrl = state.menu.security
    commit(ADMINUSER_SECURITY_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(ADMINUSER_SECURITY_SUCCESS, commitResult)
    } catch (error) {
      commit(ADMINUSER_SECURITY_FAIL, extractMessages(error))
    }
  },
  async privilegeInit({ commit, state }) {
    const apiUrl = state.menu.privileges
    commit(ADMINUSER_PRIVILEGE_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }

      commit(ADMINUSER_PRIVILEGE_SUCCESS, commitResult)
    } catch (error) {
      commit(ADMINUSER_PRIVILEGE_FAIL, extractMessages(error))
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
